import { getOneTimeRideData, downloadOneTimeRideCSV } from '../api.js'

import settings from '../settings.js'
import pageApiData from '../utils/pageApiData.js'

const [ _getOneTimeRideDataFromServer, _getOneTimeRideData, _getOneTimeRideDataSync ] = pageApiData.createFunctions(
  getOneTimeRideData,
  'Unable to get one time ride data from server.',
)

function getNumPerPage() {
  return settings.oneTimeRideList.numPerPage
}

function getCurrentPage() {
  return settings.oneTimeRideList.currentPage
}

function setCurrentPage(pageNumber) {
  settings.oneTimeRideList.currentPage = pageNumber
}

function _init() {
  // do nothing
}

_init()

export default {
  getOneTimeRideDataFromServer: _getOneTimeRideDataFromServer,
  getOneTimeRideData: _getOneTimeRideData,
  getOneTimeRideDataSync: _getOneTimeRideDataSync,
  downloadOneTimeRideCSV,

  getNumPerPage,
  getCurrentPage,
  setCurrentPage,
}
